/**
 * aminos-content-media.js
 *
 * Play/pause toggle for the optional video on the content-media section.
 * Scoped to this section's class names so it cannot cross-talk with
 * aminos-ugc-video-grid. Event-delegated at the document level so it
 * survives Shopify Section Rendering API re-mounts.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.aminos-content-media__toggle');
    if (!btn) return;
    var wrap = btn.closest('.aminos-content-media__media');
    if (!wrap) return;
    var video = wrap.querySelector('video.aminos-content-media__player');
    if (!video) return;
    e.preventDefault();
    if (video.paused) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } else {
      video.pause();
    }
  });

  document.addEventListener(
    'play',
    function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('aminos-content-media__player')) return;
      var wrap = video.closest('.aminos-content-media__media');
      var btn = wrap && wrap.querySelector('.aminos-content-media__toggle');
      if (wrap) wrap.classList.add('is-playing');
      if (btn) btn.setAttribute('aria-label', 'Pause video');
    },
    true
  );

  document.addEventListener(
    'pause',
    function (e) {
      var video = e.target;
      if (!video.classList || !video.classList.contains('aminos-content-media__player')) return;
      var wrap = video.closest('.aminos-content-media__media');
      var btn = wrap && wrap.querySelector('.aminos-content-media__toggle');
      if (wrap) wrap.classList.remove('is-playing');
      if (btn) btn.setAttribute('aria-label', 'Play video');
    },
    true
  );
})();
